import {Article, ArticleContentKey, ArticlePartContent, ArticleQuestion} from '@/model/Article';
import {ScrapedFaq} from '@/model/Scrapper';
import {isFaqSectionTitle, normalizeFaqText} from '@/service/extractFaqFromHtml';
import {stripTagsAndEntities} from '@/utils/string';

/** URL-improve must not grow an empty FAQ row. Generate still seeds one editor row. */
export function shouldSeedEmptyFaqRow(input: {
    isAnalyze?: boolean;
    questionCount: number;
    questionsLoading: boolean;
}): boolean {
    if (input.isAnalyze) {
        return false;
    }
    if (input.questionsLoading) {
        return false;
    }
    return input.questionCount === 0;
}

export function filledFaqCount(questions: ArticleQuestion[] | undefined): number {
    return (questions || []).filter(item =>
        stripTagsAndEntities(item.question) && stripTagsAndEntities(item.answer)
    ).length;
}

export function isFaqContentBlock(block: ArticlePartContent, faqs: ScrapedFaq[]): boolean {
    const headingNorm = normalizeFaqText(block.h);
    if (isFaqSectionTitle(block.h)) {
        return true;
    }
    return faqs.some(item => normalizeFaqText(item.question) === headingNorm);
}

export function faqContentPartsToRemove(article: Article, faqs: ScrapedFaq[]): Array<{contentPart: ArticleContentKey, index: number}> {
    const removals: Array<{contentPart: ArticleContentKey, index: number}> = [];
    for (let level = 1; level <= 6; level++) {
        const contentPart = ('h' + level) as ArticleContentKey;
        const blocks = article[contentPart] || [];
        for (let index = blocks.length - 1; index >= 0; index--) {
            if (isFaqContentBlock(blocks[index], faqs)) {
                removals.push({contentPart, index});
            }
        }
    }
    return removals;
}
